// extracted by mini-css-extract-plugin
export default {"root":"HaasSection_root__Wpmr0","description":"HaasSection_description__VuJJ-","summary":"HaasSection_summary__WUmbP","details":"HaasSection_details__osfG4"};